
import { Link } from 'react-router-dom';

const styleData = [
  {
    id: 1,
    title: 'ナチュラルショートボブ',
    description: '大人の女性に人気のショートボブスタイル。軽やかで扱いやすく、どんなシーンにも対応できます。',
    image: 'https://public.readdy.ai/ai/img_res/b670e59e0c13d2eee2113c258d34644b.jpg',
  },
  {
    id: 2,
    title: 'ふんわりミディアムレイヤー',
    description: '柔らかな動きが魅力のミディアムレイヤー。女性らしさを引き立てる人気のスタイルです。',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20japanese%20woman%20with%20soft%20medium%20layered%20hairstyle%2C%20natural%20wavy%20hair%20with%20gentle%20volume%2C%20warm%20brown%20hair%20color%2C%20simple%20clean%20background%20in%20soft%20beige%20tones%2C%20elegant%20asian%20woman%20with%20flowing%20medium%20length%20hair%2C%20professional%20salon%20photography%20in%20okayama&width=600&height=800&seq=style002&orientation=portrait',
  },
  {
    id: 3,
    title: 'エレガントロング',
    description: 'ツヤ感のある美しいロングヘア。上品で洗練された印象を与えるスタイルです。',
    image: 'https://readdy.ai/api/search-image?query=sophisticated%20japanese%20woman%20with%20elegant%20long%20straight%20hair%2C%20glossy%20healthy%20hair%20with%20natural%20shine%2C%20dark%20brown%20hair%20color%2C%20minimalist%20clean%20background%20in%20warm%20neutral%20tones%2C%20graceful%20asian%20woman%20showing%20beautiful%20long%20hairstyle%2C%20professional%20beauty%20salon%20photography%20in%20okayama&width=600&height=800&seq=style003&orientation=portrait',
  },
  {
    id: 4,
    title: 'カジュアルウェーブ',
    description: '自然な動きが魅力のウェーブスタイル。リラックスした雰囲気を演出します。',
    image: 'https://readdy.ai/api/search-image?query=cheerful%20japanese%20woman%20with%20casual%20wavy%20hairstyle%2C%20natural%20beach%20waves%20with%20soft%20texture%2C%20light%20brown%20hair%20with%20natural%20highlights%2C%20simple%20clean%20background%20in%20soft%20cream%20tones%2C%20friendly%20asian%20woman%20with%20relaxed%20wavy%20hair%2C%20professional%20hair%20salon%20photography%20in%20okayama&width=600&height=800&seq=style004&orientation=portrait',
  },
];

export default function StyleSection() {
  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 tracking-wider text-sub" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            STYLE
          </h2>
          <p className="text-sm sm:text-base text-sub/70 tracking-widest" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            スタイル紹介
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-12">
          {styleData.map((style) => (
            <article key={style.id} className="group cursor-pointer">
              <div className="relative h-80 sm:h-96 rounded-lg overflow-hidden mb-4 shadow-md group-hover:shadow-xl transition-all duration-300">
                <img
                  src={style.image}
                  alt={`${style.title} - 岡山市の美容室おかやま美容室`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <h3 className="text-lg sm:text-xl font-bold mb-2 text-sub tracking-wider" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                {style.title}
              </h3>
              <p className="text-sm text-sub/70 leading-relaxed">
                {style.description}
              </p>
            </article>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/style"
            className="inline-flex items-center px-6 py-3 bg-primary text-white text-sm font-semibold rounded-full hover:bg-primary/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            すべてのスタイルを見る
            <i className="ri-arrow-right-line ml-2 w-5 h-5 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
